import { supabase } from './supabaseClient.js';

export async function checkAndFixDatabase() {
  console.log('🔧 [DB FIX] Checking database schema...');
  
  try {
    // Test if we can read from books table
    const { data: books, error: booksError } = await supabase.from("books").select("*").limit(1);
    if (booksError) {
      console.error('❌ [DB FIX] Books table error:', booksError);
      return false;
    }
    console.log('✅ [DB FIX] Books table accessible');
    
    // Test if we can update a book status
    if (books && books.length > 0) {
      const testBook = books[0];
      console.log('🔧 [DB FIX] Testing book status update on:', testBook.id);
      
      const { error: updateError } = await supabase
        .from("books")
        .update({ status: testBook.status }) // Update to same status to test
        .eq('id', testBook.id);
      
      if (updateError) {
        console.error('❌ [DB FIX] Book update failed:', updateError);
        return false;
      }
      console.log('✅ [DB FIX] Book status updates work');
    }
    
    // Test if we can delete a book (create a test book first)
    console.log('🔧 [DB FIX] Testing book deletion...');
    const testBookData = {
      title: `DB_TEST_${Date.now()}`, // Use timestamp to make it obvious it's a test
      file_url: "https://example.com/test.pdf",
      status: 'test'
    };
    
    const { data: newBook, error: createError } = await supabase
      .from("books")
      .insert([testBookData])
      .select();
    
    if (createError) {
      console.error('❌ [DB FIX] Test book creation failed:', createError);
      return false;
    }
    
    if (newBook && newBook.length > 0) {
      const testBookId = newBook[0].id;
      console.log('✅ [DB FIX] Test book created:', testBookId);
      
      // Now try to delete it
      const { error: deleteError } = await supabase
        .from("books")
        .delete()
        .eq('id', testBookId);
      
      if (deleteError) {
        console.error('❌ [DB FIX] Test book deletion failed:', deleteError);
        return false;
      }
      console.log('✅ [DB FIX] Test book deletion successful');
    }
    
    console.log('✅ [DB FIX] Database operations working correctly');
    return true;
    
  } catch (error) {
    console.error('❌ [DB FIX] Database check failed:', error);
    return false;
  }
} 